module.exports = __webpack_public_path__ + "static/img/eventLow.e834e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/eventLow.png
// module id = NpL9
// module chunks = 1 3